import React, { useContext } from 'react'
import cookie from 'cookie'

import { isDynamicBundle, logError } from '../../../utils'
import { useFeatureFlags } from '../../../utils/providers'

import { BundleContext } from '../ProductBundleOptions/BundleProvider'
import {
  AddToCartButton,
  OutOfStockButton,
  PreorderButton,
  VariantButton,
} from './Buttons'

export default function ProductActionBubble({
  productData,
  disableVariants = false,
  disablePreorder = false,
}) {
  const { isFeatureEnabled } = useFeatureFlags()
  const { selectedOptions = null } = useContext(BundleContext) || {}

  const showVariants = !disableVariants && isDynamicBundle(productData)
  const showPreorder = !disablePreorder && isFeatureEnabled('product.preorder')

  let isCustomerCare = false
  if (showPreorder) {
    try {
      isCustomerCare =
        typeof document !== 'undefined' &&
        'aboUser' in cookie.parse(document.cookie)
    } catch (e) {
      logError(e, 'addToCartCustomerCare')
    }
  }

  if (productData.availability) {
    if (showVariants) {
      return <VariantButton productData={productData} />
    } else {
      return (
        <AddToCartButton
          productData={productData}
          selectedOptions={selectedOptions}
        />
      )
    }
  } else {
    if (isCustomerCare) {
      return (
        <AddToCartButton
          productData={productData}
          selectedOptions={selectedOptions}
          variant="danger"
          trackingData={{ origin: 'customer-care' }}
        />
      )
    } else if (showPreorder) {
      return <PreorderButton productData={productData} />
    } else {
      return <OutOfStockButton />
    }
  }
}
